"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledPropertyCardPhotoBody = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _PropertyCardPhotoBodyMixin = require("../../mixins/components/PropertyCardPhotoBodyMixin");
var StyledPropertyCardPhotoBody = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "StyledPropertyCardPhotoBody",
  componentId: "c11n-8-107-0__sc-yln73l-0"
})(["", ""], _PropertyCardPhotoBodyMixin.PropertyCardPhotoBodyMixin);
exports.StyledPropertyCardPhotoBody = StyledPropertyCardPhotoBody;